<template>
<div>
    <input v-model="Proxy" />

</div>
</template>
<script>
const formatter = v => {
    let value = (v||'').replace(/\D/igm, '').substr(0, 14)
    if (value.length <= 11) {
        value = value.replace(/^(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,2})/igm, '$1.$2.$3-$4').replace(/\D+$/igm, '')
    } else {
        value = value.replace(/^(\d{0,2})(\d{0,3})(\d{0,3})(\d{0,4})(\d{0,2})/igm, '$1.$2.$3.$4-$5').replace(/\D+$/igm, '')
    }
    return value
}
export default {
    props: ['value'],
    data() {
        return {
            proxy: ''
        }
    },
    computed: {
        Proxy: {
            get() {
                return this.proxy
            },
            set(v) {
                this.$emit('input', formatter(v))
                this.$forceUpdate()
            }
        }
    },
    watch: {
        value: {
            immediate: true,
            handler(v) {
                this.proxy = formatter(v)
            }
        }
    }
}
</script>